import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'
import Slide from '@material-ui/core/Slide'
import Wrapper from '../components/wrapper'
import ReportSettingsFormV3 from '../components/app-form/ReportSettingsFormV3'
import Analytics from '../components/MarketingDashboard/Analytics'
import Daily from '../components/MarketingDashboard/Daily'
import { format } from 'date-fns'
import ruLocale from 'date-fns/locale/ru'
import MDateRangePicker from '../components/MarketingDashboard/MDateRangePicker'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import { ButtonContained } from '../components/app-button/button'
import { Setting } from '../components/app-icon/Icons'
import { withSnackbar } from 'notistack'
import cx from 'classnames'

function Transition(props) {
  return <Slide direction="down" {...props} />
}

const styles = theme => ({
  dashboardWrap: {
    height: '100vh',
    background: '#f8f8f8',
  },
  appBar: {
    backgroundColor: '#8866FF',
  },
  paper: {
    backgroundColor: '#8866FF',
  },
  reportDialog: {
    backgroundColor: '#f8f8f8',
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  toolbarInner: {
    padding: 0,
  },
  reportDialogAppBar: {
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
  },
  logoRow: {
    '& a': {
      width: 80,
      height: 'auto',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '& div': {
      width: 50,
      '&:first-child': {
        height: 44,
      },
      '&:last-child': {
        height: 30,
      },
    },
  },
  appBarActions: {
    display: 'flex',
    alignItems: 'center',
  },
  appBarTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  mSettingBtn: {
    border: 0,
    outline: 'none',
    background: 'transparent',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  toggleCalendar: {
    position: 'relative',
    height: 40,
    fontSize: 16,
    padding: '0 40px 0 20px',
    whiteSpace: 'nowrap',
    lineHeight: 2.5,
    color: '#ffffff',
    marginRight: 25,
    '&:after': {
      content: "''",
      position: 'absolute',
      top: '50%',
      marginTop: -4,
      right: 16,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '8px 4px 0 4px',
      borderColor: '#ffffff transparent transparent transparent',
    },
  },
  dateRangeWrapper: {
    width: 462,
    position: 'absolute',
    top: 75,
    right: 24,
    background: '#fff',
    boxShadow: '0px 12px 12px rgba(0,0,0,0.3)',
    borderRadius: 8,
    overflow: 'hidden',
  },
  backDropDateRange: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    position: 'fixed',
    touchAction: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    WebkitTapHighlightColor: 'transparent',
  },
  overlayUpdate: {
    width: '100%',
    height: '100vh',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10000,
    position: 'fixed',
    touchAction: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    WebkitTapHighlightColor: 'transparent',
    overflow: 'hidden',
  },

  ripple: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    position: 'absolute',
    top: 'calc(50% - 30px)',
    left: 'calc(50% - 30px)',
    animationName: 'ripple',
    animationDuration: '1s',
    animationTimingFunction: 'ease-in-out',
    animationDirection: 'alternate-reverse',
    animationIterationCount: 'infinite',
    transform: 'scale(0)',
    opacity: 0.6,
  },
  ripple1: {
    backgroundColor: '#BEABFF',
  },
  ripple2: {
    animationDelay: '-250ms',
    backgroundColor: '#A68CFF',
  },
  ripple3: {
    animationDelay: '-500ms',
    backgroundColor: '#7C69BF',
  },
  ripple4: {
    animationDelay: '-750ms',
    backgroundColor: '#8866FF',
  },
  '@keyframes ripple': {
    to: { transform: 'scale(1)' },
  },
})
class Report extends Component {
  state = {
    isFetching: false,
    data: [],
    formData: [],
    chartData: [],
    openReportSettings: false,
    configurate: window.state.isReportConfigurated,
    site: window.state.site,
    startDate: '',
    endDate: '',
    showCalendar: false,
    overlayUpdateOpen: false,
    isDemo: window.state.isDemo || false,
    type: this.props.match.params.type,
  }

  componentDidMount() {
    const { configurate } = this.state
    !configurate ? this.openSettings() : this.getData()
  }

  openSettings = () => {
    this.setState({
      overlayUpdateOpen: true,
    })
    this.getSettings()
  }

  closeSettings = () => {
    this.setState({
      openReportSettings: false,
      isFetching: false,
    })
  }

  getSettings = () => {
    const url = `/reports/${this.state.type}/settings`

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(data => {
        this.setState({
          formData: data,
          openReportSettings: true,
          overlayUpdateOpen: false,
        })
      })
      .catch(errors)
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = `/reports/${this.state.type}/settings`

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(({ status }) => {
        if (status === 'ok') {
          this.setState(
            {
              isFetching: false,
              openReportSettings: false,
              configurate: true,
            },
            () => this.getData()
          )
        }
      })
      .catch(errors)
  }

  getData = () => {
    this.setState({
      overlayUpdateOpen: true,
    })

    let url = this.state.isDemo
      ? `/reports/${this.state.type}/demo`
      : `/reports/${this.state.type}/data`

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(data => {
        // console.log(data)
        this.setState({
          overlayUpdateOpen: false,
          startDate: data.fromDate,
          endDate: data.toDate,
          data,
        })
      })
      .catch(errors)
  }

  handleCalendarShow = () => {
    this.setState(prevState => {
      return {
        showCalendar: !prevState.showCalendar,
      }
    })
  }

  getRange = (startDate, endDate) => {
    this.setState({
      startDate,
      endDate,
    })
  }

  getDataWithPeriod = (startDate, endDate) => {
    this.setState({
      isFetching: true,
    })

    const formatStartDate = format(startDate, 'YYYY-MM-DD')
    const formatEndDate = format(endDate, 'YYYY-MM-DD')

    const url = `/reports/${this.state.type}/data/from/${formatStartDate}/to/${formatEndDate}`

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(data => {
        this.setState(
          {
            isFetching: false,
            startDate: data.fromDate,
            endDate: data.toDate,
            data,
          },
          () => {
            return this.handleCalendarShow()
          }
        )
      })
      .catch(errors)
  }

  updateDashboard = () => {
    this.setState({
      overlayUpdateOpen: true,
    })

    const formatStartDate = format(this.state.startDate, 'YYYY-MM-DD')
    const formatEndDate = format(this.state.endDate, 'YYYY-MM-DD')

    const url = `/reports/${this.state.type}/data/from/${formatStartDate}/to/${formatEndDate}`

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(data => {
        this.setState(
          {
            data,
          },
          () => {
            this.setState({
              overlayUpdateOpen: false,
            })
          }
        )
      })
      .catch(errors)
  }

  prepareInitialValues = () => {
    let initialValues = { goals: {} }

    this.state.formData.groupedReportGoals.map(({ type, goals }) => {
      initialValues.goals[type] = goals.map(item => {
        return {
          id: item.id,
          custom_name: item.customName,
        }
      })
    })

    return initialValues
  }

  render() {
    const {
      openReportSettings,
      isFetching,
      configurate,
      data,
      startDate,
      endDate,
      showCalendar,
      overlayUpdateOpen,
      site,
      formData,
      chartData,
      type,
    } = this.state
    const { classes } = this.props

    const fromDate = format(startDate, 'DD MMM YYYY', { locale: ruLocale })
    const toDate = format(endDate, 'DD MMM YYYY', { locale: ruLocale })

    const Project = () => (
      <a
        className={classes.container}
        href={`http://${site.url.replace(/(http|https):\/\//is, '')}`}
        target="_blank"
      >
        <div className={classes.siteIcon}>S</div>
        <ul className={classes.info}>
          <Typography component="li" variant="body1">
            {site.url}
          </Typography>
          <Typography component="li" variant="overline">
            {site.name}
          </Typography>
        </ul>
      </a>
    )

    const SettingBtn = () => (
      <button className={classes.mSettingBtn} onClick={this.openSettings}>
        <Setting width={24} height={24} fill="#8866ff" />
      </button>
    )

    const reports = () => {
      switch (type) {
        case 'analytics':
          return <Analytics data={data} settings={<SettingBtn />} />
        case 'daily':
          return <Daily data={data} />
        default:
          return null
      }
    }

    return (
      <div className={classes.dashboardWrap}>
        {overlayUpdateOpen && (
          <div className={classes.overlayUpdate}>
            <div className={classes.loading}>
              <div className={cx(classes.ripple, classes.ripple1)}></div>
              <div className={cx(classes.ripple, classes.ripple2)}></div>
              <div className={cx(classes.ripple, classes.ripple3)}></div>
              <div className={cx(classes.ripple, classes.ripple4)}></div>
            </div>
          </div>
        )}
        <AppBar className={classes.reportDialogAppBar} elevation={0}>
          <Toolbar
            style={{
              maxWidth: '100%',
              margin: '0 auto',
              width: '100%',
              height: 80,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 10px',
            }}
          >
            <div className={classes.appBarTitle}>
              <LogoData href={state.previousUrl} customClass={classes.logoRow} />
              <Project />
            </div>

            {!this.state.isDemo ? (
              <div className={classes.appBarActions}>
                <ButtonContained
                  onClick={this.handleCalendarShow}
                  customClass={classes.toggleCalendar}
                  color="secondary"
                  text={
                    startDate && endDate
                      ? `${fromDate} - ${toDate}`
                      : 'Календарь'
                  }
                />

                <ButtonContained
                  style={{
                    width: 120,
                    fontSize: 16,
                    height: 40,
                    padding: 0,
                    marginRight: 10,
                  }}
                  onClick={this.updateDashboard}
                  color="secondary"
                  text={`Обновить`}
                />

                {showCalendar && (
                  <div className={classes.dateRangeWrapper}>
                    <MDateRangePicker
                      startDate={startDate}
                      endDate={endDate}
                      getRange={this.getRange}
                      getDashboardWithPeriod={this.getDataWithPeriod}
                      toggleRange={this.handleCalendarShow}
                      isFetching={isFetching}
                    />
                  </div>
                )}

                <SettingBtn />
              </div>
            ) : (
              <ButtonContained
                href="/register?utm_source=demo_dashboard&utm_medium=button&utm_campaign=demo"
                customClass={classes.toggleCalendar}
                color="secondary"
                text="Попробовать бесплатно"
              />
            )}
          </Toolbar>
        </AppBar>
        {showCalendar && (
          <div
            className={classes.backDropDateRange}
            onClick={this.handleCalendarShow}
          />
        )}
        {data && data.length !== 0 && reports()}
        <Dialog
          fullScreen
          open={openReportSettings}
          TransitionComponent={Transition}
          PaperProps={{
            classes: {
              root: classes.paper,
            },
          }}
        >
          <div
            style={{
              maxWidth: 850,
              width: '100%',
              margin: '0 auto',
              marginTop: 70,
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <header
              style={{
                marginBottom: '5px',
              }}
            >
              <h6
                style={{
                  fontFamily: 'Roboto',
                  fontSize: 24,
                  fontWeight: 'bold',
                  fontStyle: 'normal',
                  fontStretch: 'normal',
                  lineHeight: 'normal',
                  letterSpacing: 'normal',
                  textAlign: 'center',
                  color: '#fff',
                  margin: '0 0 24px 0',
                }}
              >
                Настройки дашборда
              </h6>
            </header>
            <Wrapper
              shadow={1}
              style={{
                width: '100%',
                borderRadius: 8,
                padding: '40px 50px 50px 50px',
                backgroundColor: 'rgb(255,255,255)',
                fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
                lineHeight: 1.5,
              }}
            >
              <ReportSettingsFormV3
                data={formData}
                onSubmit={this.handleSubmit}
                isFetching={isFetching}
                isConfigurated={configurate}
                initialValues={
                  formData.groupedReportGoals &&
                  formData.groupedReportGoals.length > 0 &&
                  this.prepareInitialValues()
                }
              />
            </Wrapper>
          </div>
        </Dialog>
      </div>
    )
  }
}

export default withStyles(styles)(withSnackbar(Report))
